import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

function formatUTCDate(date) {
  return dayjs(date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]')
}

function formatToMelburnDate(date) {
  let offsetGmtHours
  date = new Date(date)
  const month = date.getMonth()
  const dayOfWeek = date.getDay() + 1
  const dayOfMonth = date.getDate()
  if (month < 3 || month > 9) {
    offsetGmtHours = 11
  } else if (month > 3 && month < 9) {
    offsetGmtHours = 10
  } else if (month === 3) { // Before and after first Sunday of April
    offsetGmtHours = dayOfWeek - dayOfMonth >= 0 ? 11 : 10
  } else if (month === 9) { // Before and after first Sunday of October
    offsetGmtHours = dayOfWeek - dayOfMonth >= 0 ? 10 : 11
  }
  date.setHours(date.getHours() - offsetGmtHours)
  return formatUTCDate(date)
}

function formatFromMelburnDate(value) {
  const options = { timeZone: 'Australia/Melbourne' }
  const date = new Date(value).toLocaleDateString('en-US', options)
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]')
}

function nextDay() {
  return dayjs().add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
}

function previousDay(value) {
  return dayjs(value).subtract(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]')
}

function dateIsAfter(dateOne, dateTwo) {
  // Check that dateOne is after dateTwo

  if (dateOne && dateTwo) {
    return dayjs(dateOne).isAfter(dayjs(dateTwo))
  } else {
    console.warn('Please provide two dates to compare')
  }
}

function activeByDate(startAt, endAt) {
  const started = dayjs().isAfter(dayjs(startAt)) || sameDate(startAt, dayjs())

  if (endAt) {
    return started && dayjs().isBefore(dayjs(endAt).endOf('day'))
  } else {
    return started
  }
}

function sameDate(dateOne, dateTwo) {
  return dayjs(dateOne).startOf('day').isSame(dayjs(dateTwo).startOf('day'))
}

function normalizeDatePickerValue(value, output = false, end = false) {
  const format = output ? 'YYYY-MM-DDTHH:mm:ssZ' : 'YYYY-MM-DD\'T\'HH:mm:ss'
  const options = { timeZone: 'Australia/Melbourne' }
  const date = new Date(dayjs(value)).toLocaleDateString('en-US', options)

  if (value) {
    return end ? dayjs(value).endOf('day').format(format) : dayjs(date).format(format)
  } else return null
}

const datePickerFormat = 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\''

export {
  formatToMelburnDate,
  formatFromMelburnDate,
  nextDay,
  datePickerFormat,
  dateIsAfter,
  activeByDate,
  sameDate,
  normalizeDatePickerValue,
  previousDay,
}
